import React from 'react';
import { Users, Briefcase, CheckCircle, Clock } from 'lucide-react';
import './AnalyticsKPICards.css';

const KPICard = ({ icon: Icon, label, value, change, changeType, isLoading }) => {
  if (isLoading) {
    return (
      <div className="kpi-card kpi-card-loading">
        <div className="kpi-skeleton kpi-skeleton-icon" />
        <div className="kpi-skeleton kpi-skeleton-value" />
        <div className="kpi-skeleton kpi-skeleton-label" />
      </div>
    );
  }

  return (
    <div className="kpi-card">
      <div className="kpi-card-header">
        <div className="kpi-icon-wrapper">
          <Icon className="kpi-icon" />
        </div>
        {change !== undefined && change !== null && (
          <span className={`kpi-change ${changeType === 'positive' ? 'positive' : changeType === 'negative' ? 'negative' : ''}`}>
            {changeType === 'positive' ? '+' : ''}{change}%
          </span>
        )}
      </div>
      <div className="kpi-value">{value ?? '-'}</div>
      <div className="kpi-label">{label}</div>
    </div>
  );
};

const AnalyticsKPICards = ({ data, isLoading }) => {
  const kpis = [
    {
      icon: Users,
      label: 'Total Candidates',
      value: data?.totalCandidates ?? 0,
      change: data?.candidatesChange,
      changeType: data?.candidatesChange >= 0 ? 'positive' : 'negative'
    },
    {
      icon: Briefcase,
      label: 'Active Applications',
      value: data?.activeApplications ?? 0,
      change: data?.applicationsChange,
      changeType: data?.applicationsChange >= 0 ? 'positive' : 'negative'
    },
    {
      icon: CheckCircle,
      label: 'Positions Filled',
      value: data?.positionsFilled ?? 0,
      change: data?.filledChange,
      changeType: data?.filledChange >= 0 ? 'positive' : 'negative'
    },
    {
      icon: Clock,
      label: 'Avg. Time to Fill',
      value: data?.avgTimeToFill ? `${data.avgTimeToFill} days` : '-',
      change: data?.timeChange,
      changeType: data?.timeChange <= 0 ? 'positive' : 'negative' // Lower is better
    }
  ];

  return (
    <div className="analytics-kpi-grid">
      {kpis.map((kpi, index) => (
        <KPICard
          key={index}
          icon={kpi.icon}
          label={kpi.label}
          value={kpi.value}
          change={kpi.change}
          changeType={kpi.changeType}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

export default AnalyticsKPICards;
